import React from "react";
import { linkFormat } from "../../utilities/linkFormat";

export default function ExternalButton(props) {
  const { buttonLink, buttonText, buttonColor } = props;

  return (
    <a className="fg-btn" href={linkFormat(buttonLink)}>
      <button>{buttonText}</button>
    </a>
  );
}
